import { createFileRoute } from "@tanstack/react-router";
import { DashboardSkeleton } from "@/pages/dashboard/DashboardSkeleton";
import { SellerProductEditorRoute } from "@/pages/dashboard/products/SellerProductEditorPage";

// One seller product's editor (docs/plans/marketplace-commerce.md M4). The dashboard layout already requires a store.
export const Route = createFileRoute("/dashboard/products_/$productId")({
  pendingComponent: DashboardSkeleton,
  component: SellerProductEditorRoute,
});
